import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// UPDATE A BRANCH
const submit = (payload) => client.put('branch', payload);
export const useUpdateBranch = (id,payload) => useMutation(['updateBranch',id],() => submit(payload))